<template>
    <div class="slider">
        <div class="icons">
            <i
                class="icon fas fa-external-link-alt mr-2"
                @click="onClickOpenUserProfile"
            />
            <i class="icon fas fa-times" @click="onClickClose" />
        </div>
        <UserInfo :user="user" @open-profile="onClickOpenUserProfile" />
        <PreCalibrationInfo :scores="user.calculated" />
        <Form
            class="form"
            :user="user"
            :nBox="nBox"
            :currentQuadrant="quadrant"
            :isSubmitting="isSubmitting"
            @submit="onSubmitUserCalibration"
        />
        <Comments :user="user" :nBox="nBox" />
        <Summaries :user="user" :periods="nBox.periods" />
    </div>
</template>
<script>
import i18n from '@/i18n'
import Avatar from 'vue-avatar'
import Aside from '@/shared/aside'
import { mapActions } from 'vuex'
import { EventBuzz } from '@/main'
import { openRouteInNewTab } from '@/lib/url'
import { calibrateUsers } from '@/views/n-box/api'
import { success, danger } from '@/lib/notification'
import {
    Summaries,
    Form,
    UserInfo,
    Comments,
    PreCalibrationInfo,
} from './components'

export default {
    components: {
        Form,
        Avatar,
        Comments,
        UserInfo,
        Summaries,
        PreCalibrationInfo,
    },
    props: {
        user: {
            type: Object,
            required: true,
        },
        nBox: {
            type: Object,
            required: true,
        },
        quadrant: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isSubmitting: false,
        }
    },
    methods: {
        ...mapActions('nBoxesReport', ['resetSliderState']),
        onClickOpenUserProfile() {
            openRouteInNewTab(this, `/v2/profile/${this.user.id}`)
        },
        onClickClose() {
            Aside.close()
            this.resetSliderState()
        },
        onSubmitUserCalibration(data) {
            this.isSubmitting = true
            calibrateUsers(this.nBox.id, [data])
                .then(() => {
                    success(i18n.t('notification.usersCalibrationSuccess'))
                })
                .catch(() => {
                    danger()
                })
                .finally(() => {
                    EventBuzz.$emit(
                        `users-calibrated-n-box-${this.nBox.id}`,
                        this.nBox.id
                    )
                    this.isSubmitting = false
                })
        },
    },
}
</script>
<style lang="scss" scoped>
.slider {
    padding: 10px;
    color: #6e6e6e;

    .icons {
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .icon {
            cursor: pointer;
            font-size: 15px;
        }
    }
}

.form {
    margin-bottom: 10px;
}
</style>
